import { createI18n } from 'vue-i18n';
import zh from './locales/zh.json';
import en from './locales/en.json';

const DEFAULT_LOCALE = 'zh';
const SUPPORTED_LOCALES = ['zh', 'en'];

const getStoredLocale = () => {
  try {
    const stored = localStorage.getItem('userLanguage');
    return SUPPORTED_LOCALES.includes(stored) ? stored : DEFAULT_LOCALE;
  } catch (_) {
    return DEFAULT_LOCALE;
  }
};

const initialLocale = getStoredLocale();

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { zh, en },
});

document.documentElement.lang = initialLocale === 'zh' ? 'zh-CN' : 'en';
document.title = initialLocale === 'zh'
  ? 'PaperNova — 科研 AI 辅助工作台'
  : 'PaperNova — AI-assisted research workspace';

export default i18n;

// Keep this small API stable so multilingual support can be restored later.
export const changeLanguage = (locale) => {
  const nextLocale = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  i18n.global.locale.value = nextLocale;
  document.documentElement.lang = nextLocale === 'zh' ? 'zh-CN' : 'en';
  document.title = nextLocale === 'zh'
    ? 'PaperNova — 科研 AI 辅助工作台'
    : 'PaperNova — AI-assisted research workspace';
  try { localStorage.setItem('userLanguage', nextLocale); } catch (_) { /* noop */ }
};

export const getCurrentLanguage = () => i18n.global.locale.value;

export const getSupportedLanguages = () => [
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'en', name: 'English', nativeName: 'English' },
];
